// src/components/TrustPilotBanner/index.jsx
import React from 'react';
import { Box, Typography, Avatar, Stack } from '@mui/material';
import person1 from './person1.png';
import person2 from './person2.png';
import person3 from './person3.png';
import ratings from './trustpilot-ratings.svg';
import logo from './trustpilot-logo.svg';

const TrustPilotBanner = () => {
  const avatars = [person1, person2, person3];

  return (
    <Box
      component="section"
      sx={{
        p: 2,
        maxWidth: 600,
        mx: 'auto',
        backgroundColor: '#F5F8FA',
        borderRadius: 2,
      }}
    >
      <Stack spacing={1}>
        <Box display="flex" alignItems="center">
          <Box
            component="img"
            src={logo}
            alt="Trustpilot logo"
            sx={{ height: 28, mr: 1 }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: { xxs: 'column', sm: 'row' },
          }}
        >
          <Box display="flex" alignItems="center">
            <Box
              component="img"
              src={ratings}
              alt="Trustpilot ratings"
              sx={{ height: { xxs: 24, xs: 32 }, mr: 1 }}
            />
            <Typography sx={{ fontSize: '16px', color: 'rgb(49, 60, 79)' }}>
              TrustScore{' '}
              <Typography
                component="span"
                sx={{ fontWeight: 'bolder', color: 'rgb(49, 60, 79)' }}
              >
                4.5
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 500,
                color: 'rgb(49, 60, 79)',
                ml: 1,
              }}
            >
              | 1,000+ reviews
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            {avatars.map((src, i) => (
              <Avatar
                key={i}
                src={src}
                sx={{
                  width: 34,
                  height: 34,
                  border: '1px solid white',
                  ml: i === 0 ? 0 : -1,
                }}
              />
            ))}
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default TrustPilotBanner;
